<form #form="ngForm" class="container-form with-nav-tabs" novalidate>
    <!--Options-->
    <div class="row container-form-options">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="save()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
            <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="container-form-content" *ngIf="entity">
        <div class="infobar">
            <sgt-usuario-infobar
                [entity]="entity">
            </sgt-usuario-infobar>
        </div>

        <div class="container-navs">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-target="#tabPrincipal" data-toggle="tab">Principal</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabEmails" data-toggle="tab">E-mails</a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" data-target="#tabUnidadesNegocios" data-toggle="tab">Unidades de Negócios</a>
                </li>                 -->
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabMarcas" data-toggle="tab" *ngIf="isTipoMercadoMarca()">Marcas</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabLinhas" data-toggle="tab">Linhas</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabAcessos" data-toggle="tab">Acessos Restritos</a>
                </li>                
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabPermissoes" data-toggle="tab">Permissões</a>
                </li>
                <li class="nav-item" *ngIf="editMode">
                    <a class="nav-link" data-target="#tabLogs" data-toggle="tab">Logs</a>
                </li>                
            </ul>
            <div class="tab-content">
                <!-- Principal -->
                <div class="tab-pane active" id="tabPrincipal">
                    <div class="row">
                        <div class="form-group col-12 col-md">
                            <label for="nome" class="col-form-label">Nome</label>
                            <input type="text" class="form-control " [(ngModel)]="entity.nome" name="nome" id="nome"
                                #nome="ngModel" required="required" maxlength="255" [autofocus]="true">
                            <sgt-form-control-error
                                *ngIf="nome.errors && nome.errors.required && nome.dirty"
                                msgError="O nome é obrigatório">
                            </sgt-form-control-error>
                            <sgt-form-control-error
                                *ngIf="nome.errors && nome.errors.maxlength"
                                msgError="O nome deve ter no máximo 255 caracteres">
                            </sgt-form-control-error>
                        </div>
                        <div class="form-group col-12 col-md-3" *ngIf="editMode">
                            <label for="situacao" class="col-form-label">Situação</label>
                            <br/>
                            <sgt-usuario-badge-situacao
                                [situacao]="entity.situacao">
                            </sgt-usuario-badge-situacao>
                        </div>
                    </div>

                    <!-- Inserindo -->
                    <div class="row" *ngIf="!editMode">
                        <div class="col-12">
                            <div class="row">
                                <div class="form-group col-12 col-md-6">
                                    <label for="login" class="col-form-label">E-mail</label>
                                    <input type="text" class="form-control" [(ngModel)]="entity.login" name="login" id="login"
                                        #login="ngModel" required="required" maxlength="100" sgtLowercase>
                                    <sgt-form-control-error
                                        *ngIf="login.errors && login.errors.required && login.dirty"
                                        msgError="O e-mail é obrigatório">
                                    </sgt-form-control-error>
                                    <sgt-form-control-error
                                        *ngIf="login.errors && login.errors.maxlength"
                                        msgError="O e-mail deve ter no máximo 100 caracteres">
                                    </sgt-form-control-error>
                                </div>
                                <div class="form-group col-12 col-md-6">
                                    <label for="senha" class="col-form-label">Senha</label>
                                    <input type="password" class="form-control" [(ngModel)]="entity.senha" name="senha" id="senha"
                                        #senha="ngModel" required="required" maxlength="100">
                                    <sgt-form-control-error
                                        *ngIf="senha.errors && senha.errors.required && senha.dirty"
                                        msgError="A senha é obrigatória">
                                    </sgt-form-control-error>
                                    <sgt-form-control-error
                                        *ngIf="senha.errors && senha.errors.maxlength"
                                        msgError="A senha deve ter no máximo 100 caracteres">
                                    </sgt-form-control-error>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Editando -->
                    <div class="row" *ngIf="editMode">
                        <div class="form-group col-12 col-md-6">
                            <label for="login" class="col-form-label">E-mail</label>
                            <div class="input-group">
                                <input type="text" class="form-control" [(ngModel)]="entity.login" name="login" id="login"
                                    #login="ngModel" required="required" maxlength="100">
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-light" (click)="openAlterarSenhaModal()" tabindex="-1">
                                        <i class="fas fa-key" aria-hidden="true"></i> <span class="d-none d-sm-inline-block">Alterar senha</span>
                                    </button>
                                </div>
                            </div>
                            <sgt-form-control-error
                                *ngIf="login.errors && login.errors.required && login.dirty"
                                msgError="O e-mail é obrigatório">
                            </sgt-form-control-error>
                            <sgt-form-control-error
                                *ngIf="login.errors && login.errors.maxlength"
                                msgError="O e-mail deve ter no máximo 100 caracteres">
                            </sgt-form-control-error>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="fone" class="col-form-label">Telefone</label>
                            <input type="tel" class="form-control" [(ngModel)]="entity.fone" name="fone" id="fone"
                                #fone="ngModel" sgtFone mask="00-0000-0000">
                            <sgt-form-control-error
                                *ngIf="fone.errors && fone.errors.foneInvalido"
                                msgError="O telefone deve ter no míninio 10 dígitos com o DDD">
                            </sgt-form-control-error>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="celular" class="col-form-label">Celular</label>
                            <input type="tel" class="form-control" [(ngModel)]="entity.celular" name="celular" id="celular"
                                #celular="ngModel" sgtFone>
                            <sgt-form-control-error
                                *ngIf="celular.errors && celular.errors.foneInvalido"
                                msgError="O celular deve ter no míninio 10 dígitos com o DDD">
                            </sgt-form-control-error>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="perfil" class="col-form-label">Perfil</label>
                            <select class="form-control" name="perfil" id="perfil"
                                [ngModel]="entity.perfil || ''" (ngModelChange)="onChangePerfil(entity.perfil = $event)"
                                #perfil="ngModel" required="required">>
                                <option value="">Selecione o perfil...</option>
                                <option *ngFor="let perfil of perfis" [ngValue]="perfil.id">{{perfil.nome}}</option>
                            </select>
                            <sgt-form-control-error
                                *ngIf="perfil.errors && perfil.errors.required && perfil.dirty"
                                msgError="O perfil é obrigatório">
                            </sgt-form-control-error>
                        </div>
                    </div>




                    <!-- Representante -->
                    <div class="row" *ngIf="isPerfilRepresentante()">
                        <div class="form-group col-12">
                            <label for="representante" class="col-form-label">Representante</label>
                            <sgt-typeahead-representante [(ngModel)]="entity.representante" name="representante" id="representante"
                                #representante="ngModel" [ngControl]="representante" [situacao]="1" required="required" [dropup]="true" [autofocus]="!editMode"
                                (typeaheadChange)="onTypeaheadChangeRepresentante($event)">
                            </sgt-typeahead-representante>
                            <sgt-form-control-error
                                *ngIf="representante.errors && representante.errors.required && representante.dirty"
                                msgError="O representante é obrigatório">
                            </sgt-form-control-error>
                        </div>
                    </div>

                    <!-- Expedição -->
                    <sgt-usuario-expedicao
                        *ngIf="isPerfilExpedicao()"
                        [entities]="entity.usuariosExpedicao"
                        #usuarioExpedicaoCadastro>
                    </sgt-usuario-expedicao>
                </div>

                <!-- E-mails -->
                <div class="tab-pane" id="tabEmails">
                    <!-- Assinatura E-mail -->
                    <sgt-usuario-email-assinatura-upload
                        *ngIf="editMode"
                        [entity]="entity">
                    </sgt-usuario-email-assinatura-upload>

                    <!-- E-mails Administrativos -->
                    <sgt-usuario-email-administrativo-form
                        [entities]="entity.emailsAdministrativos"
                        #emailAministrativoForm>
                    </sgt-usuario-email-administrativo-form>
                </div>                

                <!-- Unidades de negócios -->
                <!-- <div class="tab-pane" id="tabUnidadesNegocios">
                    <div class="row">
                        <div class="col-12">
                            <sgt-usuario-unidade-negocio
                                [nomeUsuario]="entity.nome"
                                [entities]="entity.unidadesNegocios"
                                #unidadeNegocioCadastro>
                            </sgt-usuario-unidade-negocio>
                        </div>
                    </div>
                </div>                 -->

                <!-- Marcas -->
                <div class="tab-pane" id="tabMarcas" *ngIf="isTipoMercadoMarca()">
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info" role="alert">
                                <p class="mb-0"><i class="fas fa-info" aria-hidden="true"></i> Adicione as marcas que este usuário deve ter acesso e visibilidade.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <sgt-usuario-marca
                                [entities]="entity.marcas"
                                #marcaCadastro>
                            </sgt-usuario-marca>
                        </div>
                    </div>
                </div>

                <!-- Linhas -->
                <div class="tab-pane" id="tabLinhas">
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info" role="alert">
                                <p class="mb-0"><i class="fas fa-info" aria-hidden="true"></i> Adicione as linhas que este usuário deve ter acesso e visibilidade.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <sgt-usuario-linha
                                [entities]="entity.linhas"
                                #linhaCadastro>
                            </sgt-usuario-linha>
                        </div>
                    </div>
                </div>

                <!-- Acessos Restritos -->
                <div class="tab-pane" id="tabAcessos">
                    <sgt-usuario-acessos
                        [isPerfilAdminitrador]="isPerfilAdministrador()"
                        [isPerfilRepresentante]="isPerfilRepresentante()"
                        [entity]="entity">
                    </sgt-usuario-acessos>
                </div>
                <!-- Permissões -->
                <div class="tab-pane" id="tabPermissoes">
                    <sgt-usuario-permissao
                        [entity]="entity"
                        [isPerfilRepresentante]="isPerfilRepresentante()">
                    </sgt-usuario-permissao>
                </div>
                <!-- Logs -->
                <div class="tab-pane" id="tabLogs" *ngIf="editMode">
                    <sgt-log
                        [idUsuario]="entity.id"
                        [log]="{
                            createdAt: entity.createdAt,
                            idUsuarioCreated: entity.idUsuarioCreated,
                            nomeUsuarioCreated: entity.usuarioCreated?.nome,
                            avatarUrlUsuarioCreated: entity.usuarioCreated?.avatarUrl,

                            updatedAt: entity.updatedAt,
                            idUsuarioUpdated: entity.idUsuarioUpdated,
                            nomeUsuarioUpdated: entity.usuarioUpdated?.nome,
                            avatarUrlUsuarioUpdated: entity.usuarioUpdated?.avatarUrl,
                            
                            dataInativacao: entity.dataInativacao,
                            idUsuarioInativacao: entity.idUsuarioInativacao,
                            nomeUsuarioInativacao: entity.usuarioInativacao?.nome,
                            avatarUrlUsuarioInativacao: entity.usuarioInativacao?.avatarUrl,
                            justificativaInativacao: entity.justificativaInativacao
                        }">
                    </sgt-log>
                </div>                
            </div>
        </div>
    </div>
</form>

<!-- Modal para alterar a senha -->
<sgt-usuario-altera-senha-modal
    idModal="usuarioAlteraSenhaModal"
    #usuarioAlteraSenhaModal>
</sgt-usuario-altera-senha-modal>
